import React, { Component } from 'react';
import { Page, Layout, Card, FormLayout, TextField, Banner, SettingToggle, Text, Checkbox, PageActions, Select, TextContainer, OptionList, ResourceList, ResourceItem, Tooltip, InlineStack, Icon, LegacyStack } from '@shopify/polaris';
import { InfoMinor } from '@shopify/polaris-icons';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { ColorPickerCustom } from './ColorPickerCustom';
import { EmojiPickerCustom } from './EmojiPickerCustom';
import { CountryPickerCustom } from './CountryPickerCustom';
import { CartSliderShippingBar } from './CartSliderShippingBar';
import { CartSliderCartReserved } from './CartSliderCartReserved';
import { CartSliderInCartUpsell } from './CartSliderInCartUpsell';
import { type } from 'jquery';
import { fetchApi } from './helpers/fetchApi';

const $ = window.$;

var fontStepValSmall = -2;
var fontStepValIncrease = 2

export class CartSlider extends Component {

    constructor(props, ref) {
        super(props);
        props.setIsLoading(true);
        this.saveChanges = this.saveChanges.bind(this);
        this.handleSectionSettings = this.handleSectionSettings.bind(this);
        this.updateSectionSettingsPreview = this.updateSectionSettingsPreview.bind(this);
        this.getDefaultFontValuesSectionSettings = this.getDefaultFontValuesSectionSettings.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCartReserve = this.handleCartReserve.bind(this);
        this.getDefaultFontValuesCartReserve = this.getDefaultFontValuesCartReserve.bind(this);
        this.updateCartReservePreview = this.updateCartReservePreview.bind(this);
        this.getDefaultFontValuesInCartUpsell = this.getDefaultFontValuesInCartUpsell.bind(this);
        this.updateInCartUpsellPreview = this.updateInCartUpsellPreview.bind(this);
        this.handleInCartUpsell = this.handleInCartUpsell.bind(this);
        this.handleShippingCart = this.handleShippingCart.bind(this);
        this.updateShippingCartPreview = this.updateShippingCartPreview.bind(this);
        this.getDefaultFontValuesShippingCart = this.getDefaultFontValuesShippingCart.bind(this);
        this.handleChangeOptions = this.handleChangeOptions.bind(this);
        this.togglePreviewActive = this.togglePreviewActive.bind(this);
        this.handleChangeDemoQty = this.handleChangeDemoQty.bind(this);
        this.handleDemoQtyUpDown = this.handleDemoQtyUpDown.bind(this);
        this.removeItem = this.removeItem.bind(this);

        this.state = {
            initState: {}, model: {}, DefaultFontSizeSectionSettings: {}, DefaultFontSizeCartReserve: {}, DefaultFontSizeInCartUpSell: {}, DefaultFontSizeShippingCart: {}, loading: true, common: this.props.common, selectedBundles: [], previewActive: false, demoQty: 1, visibleItem: true,
            error:
            {
                closeAfterSeconds: false,
                countdownMinutes_CartReserved: false,
                notShowHours_CartReserved: false,
                messageFontSize_CartReserved: false,
                minAmount_ShippingBar: false,
                bundledProductsCount_InCartUpsell: false,
            }
        };
    }

    componentDidMount() {
        this.populateData();
        this.props.setSaveChanges(this.saveChanges);

        // var moveTo = this.props.location.hash;
        // if (moveTo) {
        //     var handle = setInterval(function () {
        //         if (window.$(moveTo).length) {
        //             clearInterval(handle);
        //             window.location.hash = '';
        //             window.location.hash = moveTo;
        //         }
        //     }, 50);
        // }
    }

    handleChange(fieldName, newValue) {
        this.setState(prevState => {
            let model = Object.assign({}, prevState.model);
            model[fieldName] = newValue;
            this.props.setIsDirty(JSON.stringify(this.state.initState) !== JSON.stringify(model));
            return { model };
        });


    }

    handleSectionSettings(newValue) {
        this.handleChange('titleFontSize', newValue)
        this.updateSectionSettingsPreview(newValue, this.getDefaultFontValuesSectionSettings())

    }

    handleCartReserve(newValue) {
        this.handleChange('cartInfoFontSize_CartReserved', newValue)
        this.updateCartReservePreview(newValue, this.getDefaultFontValuesCartReserve())
    }

    handleInCartUpsell(newValue) {
        this.handleChange('cartFontSize_InCartUpsell', newValue)
        this.updateInCartUpsellPreview(newValue, this.getDefaultFontValuesInCartUpsell())
    }

    handleShippingCart(newValue) {
        this.handleChange('shippingFontSize_ShippingBar', newValue)
        this.updateShippingCartPreview(newValue, this.getDefaultFontValuesShippingCart())
    }

    getDefaultFontValuesShippingCart() {
        if (Object.keys(this.state.DefaultFontSizeShippingCart).length === 0) {
            let elements = {
                shippingCartText1: window.$('.satcb-cs-shippingbar span'),
            }

            var fontSizes = {};
            window.$.each(elements, (key, val) => {
                fontSizes[key] = parseFloat(val.css('font-size'));
            });

            this.setState({ DefaultFontSizeShippingCart: fontSizes })
            return fontSizes;
        }
    }

    updateShippingCartPreview(value, defaultFont) {

        let elements = {
            shippingCartText1: window.$('.satcb-cs-shippingbar span'),
        }

        if (defaultFont === undefined) {
            defaultFont = this.state.DefaultFontSizeShippingCart;
        }

        if (value === "") {
            window.$.each(defaultFont, (key, size) => {
                elements[key].css('font-size', defaultFont[key] + 'px');
            });
            return;
        }

        let stepVal = parseFloat(value);
        window.$.each(defaultFont, (key, size) => {
            let newSize = size + stepVal;
            elements[key].css('font-size', newSize + 'px');
        });
    }


    getDefaultFontValuesInCartUpsell() {

        if (Object.keys(this.state.DefaultFontSizeInCartUpSell).length === 0) {
            let elements = {
                inCartUpsellText1: window.$('.satcb-cs-upsell-item-header span'),
                inCartUpsellTitle: window.$('.satcb-cs-upsell-item-title'),
                inCartUpsellQty: window.$('.satcb-cs-upsell-item-content .satcb-cs-item-qty input[type=text]'),
                inCartUpsellPrice: window.$('.satcb-cs-upsell-item-price'),
                inCartUpsellBtn: window.$('.satcb-cs-upsell-item-atc')
            }

            var fontSizes = {};
            window.$.each(elements, (key, val) => {
                fontSizes[key] = parseFloat(val.css('font-size'));
            });

            this.setState({ DefaultFontSizeInCartUpSell: fontSizes });

            return fontSizes;
        }

    }

    updateInCartUpsellPreview(value, defaultFont) {
        let elements = {
            inCartUpsellText1: window.$('.satcb-cs-upsell-item-header span'),
            inCartUpsellTitle: window.$('.satcb-cs-upsell-item-title'),
            inCartUpsellQty: window.$('.satcb-cs-upsell-item-content .satcb-cs-item-qty input[type=text]'),
            inCartUpsellPrice: window.$('.satcb-cs-upsell-item-price'),
            inCartUpsellBtn: window.$('.satcb-cs-upsell-item-atc')
        }

        if (defaultFont === undefined) {
            defaultFont = this.state.DefaultFontSizeInCartUpSell;
        }
        if (value === "") {
            $.each(defaultFont, (key, size) => {
                elements[key].css('font-size', defaultFont[key] + 'px');
            });
            return;
        }

        let stepVal = parseFloat(value);
        window.$.each(defaultFont, (key, size) => {
            let newSize = size + stepVal;
            elements[key].css('font-size', newSize + 'px');
        });
    }

    getDefaultFontValuesSectionSettings() {

        if (Object.keys(this.state.DefaultFontSizeSectionSettings).length === 0) {
            var elements = {
                title: window.$('.satcb-cs-header-title'),
                countVal: window.$('.satcb-cs-header-count'),
                subTotal: window.$('.satcb-cs-footer-subtotal span:first-child'),
                subTotalPrice: window.$('.satcb-cs-footer-subtotal span:last-child'),
                textShipping: window.$('.satcb-cs-taxes-shipping-note'),
                checkoutBtn: window.$('.satcb-cs-checkout-btn'),
                viewCart: window.$('.satcb-cs-view-cart'),
                continueShopping: window.$('.satcb-cs-continue-shopping'),
                proTitle: window.$('.satcb-cs-items .satcb-cs-item .satcb-cs-item-title a'),
                proQuantity: window.$('.satcb-cs-items .satcb-cs-item-qty input[type=text]'),
                proPrice: window.$('.satcb-cs-items .satcb-cs-item-price'),
                proVariant: window.$('.satcb-cs-items .satcb-cs-item-variant')
            };

            var fontSizes = {};
            window.$.each(elements, (key, val) => {
                fontSizes[key] = parseFloat(val.css('font-size'));
            });

            this.setState({ DefaultFontSizeSectionSettings: fontSizes });

            return fontSizes;
        }
    }

    updateSectionSettingsPreview(Value, defaultFont) {
        var elements = {
            title: window.$('.satcb-cs-header-title'),
            countVal: window.$('.satcb-cs-header-count'),
            subTotal: window.$('.satcb-cs-footer-subtotal span:first-child'),
            subTotalPrice: window.$('.satcb-cs-footer-subtotal span:last-child'),
            textShipping: window.$('.satcb-cs-taxes-shipping-note'),
            checkoutBtn: window.$('.satcb-cs-checkout-btn'),
            viewCart: window.$('.satcb-cs-view-cart'),
            continueShopping: window.$('.satcb-cs-continue-shopping'),
            proTitle: window.$('.satcb-cs-items .satcb-cs-item .satcb-cs-item-title a'),
            proQuantity: window.$('.satcb-cs-items .satcb-cs-item-qty input[type=text]'),
            proPrice: window.$('.satcb-cs-items .satcb-cs-item-price'),
            proVariant: window.$('.satcb-cs-items .satcb-cs-item-variant')
        };

        if (defaultFont === undefined) {
            defaultFont = this.state.DefaultFontSizeSectionSettings;
        }
        if (Value === "") {
            window.$.each(defaultFont, (key, size) => {
                elements[key].css('font-size', defaultFont[key] + 'px');
            });
            return;
        }

        let stepVal = parseFloat(Value);
        window.$.each(defaultFont, (key, size) => {
            let newSize = size + stepVal;
            elements[key].css('font-size', newSize + 'px');
        });
    }

    getDefaultFontValuesCartReserve() {

        if (Object.keys(this.state.DefaultFontSizeCartReserve).length === 0) {
            let elements = {
                cartReserveText1: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-bold').prev(),
                cartReserveText2: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-bold span:first-child'),
                cartReserveTime: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-timer'),
                cartReserveText3: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-timer').next(),
            }


            var fontSizes = {};
            window.$.each(elements, (key, val) => {
                fontSizes[key] = parseFloat(val.css('font-size'));
            });

            this.setState({ DefaultFontSizeCartReserve: fontSizes });

            return fontSizes;
        }
    }

    updateCartReservePreview(value, defaultFont) {

        let elements = {
            cartReserveText1: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-bold').prev(),
            cartReserveText2: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-bold span:first-child'),
            cartReserveTime: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-timer'),
            cartReserveText3: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-timer').next(),
        }

        if (defaultFont === undefined) {
            defaultFont = this.state.DefaultFontSizeCartReserve;
        }

        if (value === "") {
            window.$.each(defaultFont, (key, size) => {
                elements[key].css('font-size', defaultFont[key] + 'px');
            });
            return;
        }

        let stepVal = parseFloat(value);
        window.$.each(defaultFont, (key, size) => {
            let newSize = size + stepVal;
            elements[key].css('font-size', newSize + 'px');
        });
    }


    handleChangeOptions(newValue) {
        if (newValue == '0') {
            this.handleChange('clearLowQuantityItemsFromCartOnTimerEnd_CartReserved', false);
            this.handleChange('clearCartOnTimerEnd_CartReserved', false);
            this.handleChange('selectedRemoveProductOption_CartReserved', '0');
        } else if (newValue == '1') {
            this.handleChange('clearLowQuantityItemsFromCartOnTimerEnd_CartReserved', true);
            this.handleChange('clearCartOnTimerEnd_CartReserved', false);
            this.handleChange('selectedRemoveProductOption_CartReserved', '1');
        } else if (newValue == '2') {
            this.handleChange('clearCartOnTimerEnd_CartReserved', true);
            this.handleChange('clearLowQuantityItemsFromCartOnTimerEnd_CartReserved', false);
            this.handleChange('selectedRemoveProductOption_CartReserved', '2');
        }
    }

    selectBundles(newValue) {
        this.setState({ selectedBundles: newValue });
    }

    deleteBundles() {
        var items = this.state.model.bundles_InCartUpsell.filter((option) => this.state.selectedBundles.indexOf(option.id) === -1);
        this.handleChange('bundles_InCartUpsell', items);
        this.selectBundles([]);
    }

    togglePreviewActive() {
        var showDemo = !this.state.previewActive;
        this.setState({ previewActive: showDemo });

        setTimeout(function () {
            if (showDemo) {
                window.$('.satcb-cs').addClass('satcb-cs-open');
                window.$('body').addClass('satcb-cs-modal-open');
                window.$('.satcb-cs-content').animate({ 'margin-right': "0" }, 400);
            }
            else {
                window.$('.satcb-cs-content').animate({ 'margin-right': -window.$('.satcb-cs-content').width() }, 400, function () {
                    window.$('.satcb-cs').removeClass('satcb-cs-open');
                    window.$('body').removeClass('satcb-cs-modal-open');
                });
            }
        }, 0);
    }

    handleChangeDemoQty(event) {
        this.setState({ demoQty: event.target.value });
    }

    handleDemoQtyUpDown(value, e) {
        e.preventDefault();
        var val = this.state.demoQty + value;
        if (val > 0) {
            this.setState({ demoQty: val });
        }
    }

    handleBlur(fieldName, minValue) {
        var val = parseFloat(this.state.model[fieldName]);
        var hasError = !(val >= minValue);

        this.setState(prevState => {
            let error = Object.assign({}, prevState.error);
            error[fieldName] = hasError;
            return { error };
        });

        return hasError;
    }

    removeItem() {
        this.setState({ visibleItem: false });
    }

    getCurrencySymbol() {
        var symbol = this.state.common.currency;
        switch (symbol) {
            case 'USD':
                symbol = '$';
                break;
            case 'EUR':
                symbol = '€';
                break;
            default:
                symbol += ' ';
                break;
        }

        return symbol;
    }

    render() {
        let token = !window.navigate ? `&token=${new URLSearchParams(window.location.search).get("token")}` : "";

        let lblCustomBundles = <span>
            <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">
                Custom Bundles
            </b>
            <br />
            <span>
                Consider bundling related or frequently purchased items together.
            </span>
        </span>;

        let lblSmartRecommendation = <span>
            <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">
                Smart recommendations
            </b>
            <br />
            <span>
                Leverage the customer's purchase history and behavior to suggest products they are likely to be interested in.
            </span>
        </span>;

        let lblGlobalRecommendation = <span>
            <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">
                Global recommendations
                <Tooltip content="To add products as global recommendations tag them with the exact text 'Global upsell recommendations'">
                    <div style={{ lineHeight: 'normal', marginLeft: '4px', display: 'inline-block', marginBottom: '-4px' }}>
                        <Icon source={InfoMinor} color="inkLightest" />
                    </div>
                </Tooltip>
            </b>
            <br />
            <span>
                Based on manual tagging of products, use for promoting seasonal or trending items, bestsellers, or special promotions.
            </span>
        </span>;

        let lblSameCollection = <span>
            <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">
                Same Collection
            </b>
            <br />
            <span>
                Suggests products within the same collection, which often share a theme or purpose.
            </span>
        </span>;
        let lblSameProductType = <span>
            <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">
                Same Product Type
            </b>
            <br />
            <span>
                Recommending products of the same type, like different laptop models, can help customers find alternatives or upgrades.
            </span>
        </span>;

        let lblSameVendor = <span>
            <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">
                Same Vendor
            </b>
            <br />
            <span>
                Promotes items that are compatible in terms of brand or manufacturer.
            </span>
        </span>;
        let lblRandomProduct = <span>
            <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">
                Random Product
            </b>
            <br />
            <span>
                When other recommendations don't apply, random products offer variety and can spark interest, helping customers discover new products.
            </span>
        </span>;



        return (
            this.state.loading ?
                <SkeletonPageCustom />
                :
                <Page title="Cart Slider">
                        {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed <= 0 && (
                            <Banner
                                title={`Free Plan Usage Limit Reached: App Paused Until ${(new Date(this.props.common.freePlanCreditsResetDate)).toLocaleString(undefined, {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                })}`}
                                status="critical"
                                action={{
                                    content: 'Upgrade now', onAction: () => {
                                        const params = new URLSearchParams(this.state.url);
                                        const shop = params.get("shop");
                                        const host = params.get("host");
                                        window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                    }
                                }}
                            >
                                <p>
                                    Your store is currently on the Free plan whose limit is reached and the STKTY app is paused until your next 30-day cycle. Upgrade your plan now to avoid disruptions.
                                </p>
                            </Banner>
                        )}

                        {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed > 0 && (
                            <Banner
                                title={`Free Plan Usage: ${this.props.common.freePlanClicksUsed >= 0 ? this.props.common.freePlanClicksUsed : 0} clicks left out of 25`}
                                status="warning"
                                action={{
                                    content: 'View plans', onAction: () => {
                                        const params = new URLSearchParams(this.state.url);
                                        const shop = params.get("shop");
                                        const host = params.get("host");
                                        window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                    }
                                }}
                            >
                                <p>
                                    Your store is currently on the Free plan. Once 25 clicks are reached, all STKY widgets will be paused until your next 30-day cycle. Upgrade your plan today to avoid disruptions.
                                </p>
                            </Banner>
                        )}
                    <br/>
                    <div className="satcb-cs">
                        <div className="satcb-cs-content" style={{ fontFamily: this.state.model.fontFace }}>
                            <div className="satcb-cs-header">
                                <span className="satcb-cs-header-title">{this.state.model.cartTitle_Translation} <span className="satcb-cs-header-count">{this.state.demoQty}</span></span>
                                <span className="satcb-cs-close" onClick={this.togglePreviewActive}></span>
                            </div>
                            <div className="satcb-cs-top-container">
                                {
                                    this.state.model.enabled_CartReserved && this.state.model.position_CartReserved === 'top' ?
                                        <CartSliderCartReserved
                                            model={this.state.model}
                                        /> : ''
                                }
                                {
                                    this.state.model.enabled_ShippingBar && this.state.model.position_ShippingBar === 'top' ?
                                        <CartSliderShippingBar
                                            model={this.state.model}
                                            totalPrice={this.state.model.demoProduct ? this.state.model.demoProduct.defaultVariant.price : 0}
                                            currency={this.getCurrencySymbol()}
                                        /> : ''
                                }
                                {
                                    this.state.visibleItem && this.state.model.enabled_InCartUpsell && this.state.model.position_InCartUpsell === 'top' ?
                                        <CartSliderInCartUpsell
                                            model={this.state.model}
                                            product={this.state.model.demoProduct}
                                            currency={this.getCurrencySymbol()}
                                        /> : ''
                                }
                            </div>
                            <div className={'satcb-cs-items' + (!this.state.visibleItem ? ' satcb-cs-cart-empty' : '')}>
                                {
                                    this.state.visibleItem ?
                                        <div className="satcb-cs-item">
                                            <div className="satcb-cs-item-img">
                                                <a href={this.state.model.demoProduct.url} target="_blank" rel="noreferrer"><img src={this.state.model.demoProduct.imageUrl} alt={this.state.model.demoProduct.title} /></a>
                                            </div>
                                            <div className="satcb-cs-item-main">
                                                <div className="satcb-cs-item-main-top">
                                                    <div className="satcb-cs-item-main-top-left">
                                                        <div className="satcb-cs-item-title">
                                                            <a href={this.state.model.demoProduct.url} target="_blank" rel="noreferrer">{this.state.model.demoProduct.title}</a>
                                                        </div>
                                                        <div className="satcb-cs-item-variant">{this.state.model.demoProduct.defaultVariant.title}</div>
                                                    </div>
                                                </div>
                                                <span className="satcb-cs-item-close" onClick={this.removeItem}></span>
                                                <div className="satcb-cs-item-main-bottom">
                                                    <div className="satcb-cs-item-qty">
                                                        <a href="/#" onClick={(e) => this.handleDemoQtyUpDown(-1, e)}><svg width="10" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z"></path></svg></a>
                                                        <input type="text" value={this.state.demoQty} onChange={this.handleChangeDemoQty} />
                                                        <a href="/#" onClick={(e) => this.handleDemoQtyUpDown(1, e)}><svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z"></path></svg></a>
                                                    </div>
                                                    <span className="satcb-cs-item-price">
                                                        {this.getCurrencySymbol() + this.state.model.demoProduct.defaultVariant.price}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div>{this.state.model.cartEmptyText_Translation}</div>
                                }
                            </div>
                            <div className="satcb-cs-bottom-container">
                                {
                                    this.state.model.enabled_CartReserved && this.state.model.position_CartReserved === 'bottom' ?
                                        <CartSliderCartReserved
                                            model={this.state.model}
                                        /> : ''
                                }
                                {
                                    this.state.model.enabled_ShippingBar && this.state.model.position_ShippingBar === 'bottom' ?
                                        <CartSliderShippingBar
                                            model={this.state.model}
                                            totalPrice={this.state.model.demoProduct ? this.state.model.demoProduct.defaultVariant.price : 0}
                                            currency={this.getCurrencySymbol()}
                                        /> : ''
                                }
                                {
                                    this.state.visibleItem && this.state.model.enabled_InCartUpsell && this.state.model.position_InCartUpsell === 'bottom' ?
                                        <CartSliderInCartUpsell
                                            model={this.state.model}
                                            product={this.state.model.demoProduct}
                                            currency={this.getCurrencySymbol()}
                                        /> : ''
                                }
                            </div>

                            {
                                this.state.model.showTrustBadges ?
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        {
                                            this.state.model.showTrustBadgesVisa ?
                                                <div className="trustbadgeicons">

                                                    <svg width="50" height="48" viewBox="0 0 70 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.2505 32.5165H17.0099L13.8299 20.3847C13.679 19.8267 13.3585 19.3333 12.8871 19.1008C11.7106 18.5165 10.4142 18.0514 9 17.8169V17.3498H15.8313C16.7742 17.3498 17.4813 18.0514 17.5991 18.8663L19.2491 27.6173L23.4877 17.3498H27.6104L21.2505 32.5165ZM29.9675 32.5165H25.9626L29.2604 17.3498H33.2653L29.9675 32.5165ZM38.4467 21.5514C38.5646 20.7346 39.2717 20.2675 40.0967 20.2675C41.3931 20.1502 42.8052 20.3848 43.9838 20.9671L44.6909 17.7016C43.5123 17.2345 42.216 17 41.0395 17C37.1524 17 34.3239 19.1008 34.3239 22.0165C34.3239 24.2346 36.3274 25.3992 37.7417 26.1008C39.2717 26.8004 39.861 27.2675 39.7431 27.9671C39.7431 29.0165 38.5646 29.4836 37.3881 29.4836C35.9739 29.4836 34.5596 29.1338 33.2653 28.5494L32.5582 31.8169C33.9724 32.3992 35.5025 32.6338 36.9167 32.6338C41.2752 32.749 43.9838 30.6502 43.9838 27.5C43.9838 23.5329 38.4467 23.3004 38.4467 21.5514ZM58 32.5165L54.82 17.3498H51.4044C50.6972 17.3498 49.9901 17.8169 49.7544 18.5165L43.8659 32.5165H47.9887L48.8116 30.3004H53.8772L54.3486 32.5165H58ZM51.9936 21.4342L53.1701 27.1502H49.8723L51.9936 21.4342Z" fill="#172B85" />
                                                    </svg>

                                                </div> : ''
                                        }
                                        {
                                            this.state.model.showTrustBadgesMastercard ?
                                                <div className="trustbadgeicons">

                                                    <svg width="50" height="48" viewBox="0 0 70 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M35.5 34.3139C33.1169 36.3704 30.0255 37.6119 26.6475 37.6119C19.1102 37.6119 13 31.4308 13 23.806C13 16.1811 19.1102 10 26.6475 10C30.0255 10 33.1169 11.2415 35.5 13.2981C37.8831 11.2415 40.9745 10 44.3525 10C51.8898 10 58 16.1811 58 23.806C58 31.4308 51.8898 37.6119 44.3525 37.6119C40.9745 37.6119 37.8831 36.3704 35.5 34.3139Z" fill="#ED0006" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M35.5 34.3139C38.4344 31.7816 40.2951 28.0136 40.2951 23.806C40.2951 19.5983 38.4344 15.8303 35.5 13.2981C37.8831 11.2415 40.9745 10 44.3524 10C51.8898 10 58 16.1811 58 23.806C58 31.4308 51.8898 37.6119 44.3524 37.6119C40.9745 37.6119 37.8831 36.3704 35.5 34.3139Z" fill="#F9A000" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M35.5 13.2981C38.4344 15.8304 40.2951 19.5984 40.2951 23.806C40.2951 28.0136 38.4344 31.7816 35.5 34.3138C32.5657 31.7816 30.705 28.0136 30.705 23.806C30.705 19.5984 32.5657 15.8304 35.5 13.2981Z" fill="#FF5E00" />
                                                    </svg>

                                                </div> : ''
                                        }
                                        {
                                            this.state.model.showTrustBadgesAmericanExpress ?
                                                <div className="trustbadgeicons">

                                                    <svg width="50" height="48" viewBox="0 0 70 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="#1F72CD" stroke="#D9D9D9" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5493 17L6 31.4935H13.8405L14.8125 29.1826H17.0342L18.0062 31.4935H26.6364V29.7298L27.4054 31.4935H31.8696L32.6386 29.6925V31.4935H50.587L52.7695 29.2426L54.813 31.4935L64.0317 31.5121L57.4617 24.2872L64.0317 17H54.956L52.8315 19.2093L50.8523 17H31.3268L29.6501 20.7409L27.9341 17H20.11V18.7037L19.2396 17H12.5493ZM39.3516 19.0581H49.6584L52.8108 22.4633L56.0648 19.0581H59.2172L54.4275 24.2852L59.2172 29.452H55.9218L52.7695 26.0073L49.4989 29.452H39.3516V19.0581ZM41.8968 23.1099V21.2114V21.2096H48.328L51.1342 24.2458L48.2036 27.2986H41.8968V25.226H47.5197V23.1099H41.8968ZM14.0664 19.0581H17.8883L22.2324 28.8862V19.0581H26.4191L29.7745 26.1048L32.8668 19.0581H37.0326V29.4581H34.4978L34.4771 21.3087L30.7817 29.4581H28.5142L24.7981 21.3087V29.4581H19.5836L18.595 27.1266H13.254L12.2675 29.4561H9.47358L14.0664 19.0581ZM14.166 24.9712L15.9256 20.8177L17.6832 24.9712H14.166Z" fill="white" />
                                                    </svg>

                                                </div> : ''
                                        }
                                        {
                                            this.state.model.showTrustBadgesPaypal ?
                                                <div className="trustbadgeicons">

                                                    <svg width="50" height="48" viewBox="0 0 70 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.8 30.4819H16.6888C16.4759 30.4819 16.2948 30.6366 16.2616 30.8467L15.0033 38.8248C14.9783 38.9823 15.1002 39.1242 15.2599 39.1242H16.7452C16.9581 39.1242 17.1392 38.9695 17.1724 38.7589L17.5118 36.6072C17.5445 36.3964 17.726 36.2419 17.9385 36.2419H18.9234C20.9729 36.2419 22.1556 35.2501 22.4647 33.2848C22.6038 32.425 22.4705 31.7495 22.0678 31.2762C21.6257 30.7568 20.8413 30.4819 19.8 30.4819ZM20.159 33.3958C19.9889 34.5122 19.1358 34.5122 18.3111 34.5122H17.8416L18.1709 32.4271C18.1905 32.3012 18.2997 32.2084 18.4271 32.2084H18.6422C19.2041 32.2084 19.7341 32.2084 20.008 32.5286C20.1712 32.7198 20.2213 33.0036 20.159 33.3958ZM29.1002 33.36H27.6103C27.4834 33.36 27.3737 33.4528 27.3541 33.5789L27.2882 33.9956L27.184 33.8446C26.8615 33.3764 26.1423 33.22 25.4244 33.22C23.7779 33.22 22.3718 34.4669 22.0979 36.2162C21.9556 37.0886 22.1579 37.9229 22.6529 38.5048C23.107 39.0398 23.7567 39.2627 24.5295 39.2627C25.856 39.2627 26.5918 38.4097 26.5918 38.4097L26.5253 38.8238C26.5002 38.9821 26.6221 39.124 26.7809 39.124H28.123C28.3365 39.124 28.5165 38.9693 28.5501 38.7587L29.3554 33.6594C29.3809 33.5025 29.2594 33.36 29.1002 33.36ZM27.0234 36.2598C26.8796 37.1109 26.204 37.6823 25.3426 37.6823C24.9099 37.6823 24.564 37.5436 24.3421 37.2806C24.1219 37.0196 24.0381 36.6478 24.1082 36.2339C24.2425 35.3899 24.9295 34.8 25.7779 34.8C26.2009 34.8 26.5449 34.9404 26.7714 35.2057C26.9983 35.4737 27.0885 35.8476 27.0234 36.2598ZM35.5379 33.3598H37.0352C37.2449 33.3598 37.3672 33.5949 37.2481 33.7669L32.2685 40.9547C32.1878 41.0712 32.055 41.1404 31.9131 41.1404H30.4177C30.2072 41.1404 30.0842 40.9034 30.2061 40.7309L31.7567 38.5423L30.1076 33.7027C30.0506 33.5345 30.1748 33.3598 30.3537 33.3598H31.8249C32.016 33.3598 32.1847 33.4852 32.2398 33.6682L33.115 36.5911L35.1801 33.5495C35.2609 33.4307 35.3952 33.3598 35.5379 33.3598Z" fill="#253B80" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M51.7709 38.8248L53.0478 30.7008C53.0673 30.5747 53.1766 30.4818 53.3035 30.4814H54.741C54.8998 30.4814 55.0217 30.6237 54.9966 30.7812L53.7374 38.7589C53.7046 38.9694 53.5235 39.1242 53.3103 39.1242H52.0265C51.8677 39.1242 51.7459 38.9823 51.7709 38.8248ZM41.9921 30.4818H38.8803C38.6679 30.4818 38.4869 30.6366 38.4536 30.8467L37.1953 38.8248C37.1702 38.9823 37.2921 39.1242 37.4511 39.1242H39.0477C39.1961 39.1242 39.3231 39.0159 39.3462 38.8686L39.7033 36.6071C39.7361 36.3964 39.9176 36.2418 40.13 36.2418H41.1145C43.1644 36.2418 44.3469 35.25 44.6562 33.2848C44.7957 32.425 44.6616 31.7494 44.2591 31.2761C43.8172 30.7568 43.0334 30.4818 41.9921 30.4818ZM42.3511 33.3957C42.1814 34.5121 41.3284 34.5121 40.5031 34.5121H40.034L40.3639 32.4271C40.3835 32.3012 40.4917 32.2084 40.6195 32.2084H40.8347C41.3961 32.2084 41.9267 32.2084 42.2004 32.5286C42.3637 32.7197 42.4134 33.0035 42.3511 33.3957ZM51.2915 33.3599H49.8027C49.6747 33.3599 49.5661 33.4528 49.5469 33.5789L49.481 33.9955L49.3764 33.8446C49.0538 33.3764 48.3351 33.2199 47.6172 33.2199C45.9707 33.2199 44.565 34.4669 44.2911 36.2162C44.1492 37.0886 44.3507 37.9229 44.8456 38.5048C45.3006 39.0397 45.9494 39.2627 46.7223 39.2627C48.0488 39.2627 48.7844 38.4096 48.7844 38.4096L48.7181 38.8237C48.693 38.9821 48.8149 39.1239 48.9747 39.1239H50.3162C50.5286 39.1239 50.7096 38.9692 50.7429 38.7587L51.5486 33.6593C51.5732 33.5025 51.4513 33.3599 51.2915 33.3599ZM49.2149 36.2597C49.072 37.1109 48.3955 37.6823 47.5338 37.6823C47.1021 37.6823 46.7555 37.5435 46.5334 37.2806C46.3132 37.0195 46.2305 36.6477 46.2997 36.2338C46.4347 35.3898 47.1208 34.7999 47.9692 34.7999C48.3924 34.7999 48.7362 34.9404 48.9629 35.2056C49.1907 35.4736 49.2808 35.8475 49.2149 36.2597Z" fill="#179BD7" />
                                                        <path d="M31.314 27.6277L31.6966 25.1982L30.8446 25.1785H26.7761L29.6035 7.25079C29.6121 7.19667 29.6408 7.14621 29.6824 7.11037C29.7241 7.07454 29.7776 7.05479 29.8332 7.05479H36.6932C38.9707 7.05479 40.5423 7.52871 41.3629 8.4641C41.7475 8.90292 41.9926 9.36147 42.1111 9.86611C42.2353 10.3956 42.2376 11.0282 42.1162 11.7998L42.1073 11.8561V12.3505L42.4922 12.5685C42.8162 12.7403 43.0734 12.9371 43.2709 13.1623C43.6002 13.5375 43.813 14.0143 43.9029 14.5797C43.9957 15.1611 43.965 15.853 43.813 16.6362C43.6374 17.5373 43.3536 18.322 42.9705 18.9641C42.6178 19.5558 42.1688 20.0464 41.6357 20.4269C41.1267 20.7881 40.5218 21.0624 39.838 21.238C39.1753 21.4104 38.4199 21.4976 37.5913 21.4976H37.0574C36.6757 21.4976 36.3048 21.6351 36.0138 21.8816C35.722 22.1332 35.5288 22.4768 35.4696 22.8528L35.4294 23.0715L34.7536 27.3534L34.7229 27.5107C34.7149 27.5606 34.701 27.5854 34.6806 27.6023C34.6622 27.6174 34.6359 27.6277 34.6102 27.6277H31.314Z" fill="#253B80" />
                                                        <path d="M42.8564 11.9134C42.836 12.0443 42.8126 12.1781 42.7863 12.3156C41.8814 16.9605 38.7865 18.5651 34.8334 18.5651H32.8208C32.3374 18.5651 31.93 18.9161 31.8547 19.3929L30.8241 25.9284L30.5323 27.7808C30.4833 28.0939 30.7248 28.3762 31.0406 28.3762H34.6105C35.0332 28.3762 35.3922 28.069 35.4587 27.6522L35.4938 27.4707L36.166 23.2054L36.2092 22.9715C36.2749 22.5532 36.6347 22.2461 37.0574 22.2461H37.5913C41.0498 22.2461 43.7574 20.8418 44.5488 16.7784C44.8793 15.0809 44.7082 13.6635 43.8334 12.6667C43.5688 12.3661 43.2404 12.1167 42.8564 11.9134Z" fill="#179BD7" />
                                                        <path d="M41.9096 11.5363C41.7715 11.4961 41.6288 11.4595 41.4825 11.4266C41.3355 11.3945 41.1848 11.3659 41.0298 11.3411C40.4871 11.2533 39.8926 11.2116 39.2555 11.2116H33.8787C33.7463 11.2116 33.6206 11.2416 33.5079 11.2957C33.2599 11.4149 33.0757 11.6497 33.0311 11.9371L31.8871 19.1819L31.8542 19.3933C31.9296 18.9164 32.337 18.5654 32.8204 18.5654H34.833C38.7861 18.5654 41.8812 16.9601 42.7859 12.316C42.8128 12.1785 42.8355 12.0446 42.856 11.9137C42.6271 11.7923 42.3791 11.6885 42.1122 11.6C42.0465 11.578 41.9785 11.5568 41.9096 11.5363Z" fill="#222D65" />
                                                        <path d="M33.0311 11.937C33.0758 11.6495 33.2602 11.4148 33.508 11.2963C33.6215 11.2422 33.7465 11.2122 33.8787 11.2122H39.2558C39.8928 11.2122 40.4874 11.2539 41.0299 11.3416C41.185 11.3665 41.3358 11.395 41.4827 11.4272C41.629 11.4601 41.7716 11.4967 41.9099 11.5369C41.9785 11.5574 42.0465 11.5786 42.1131 11.5998C42.38 11.6883 42.628 11.7929 42.8568 11.9136C43.1261 10.1971 42.8547 9.02837 41.9267 7.97009C40.9036 6.80505 39.0568 6.30627 36.6939 6.30627H29.8337C29.3509 6.30627 28.9393 6.65731 28.8646 7.13489L26.0073 25.2468C25.9509 25.6052 26.2273 25.9285 26.5886 25.9285H30.824L31.8873 19.1817L33.0311 11.937Z" fill="#253B80" />
                                                    </svg>

                                                </div> : ''
                                        }
                                        {
                                            this.state.model.showTrustBadgesGPay ?
                                                <div className="trustbadgeicons">

                                                    <svg width="50" height="48" viewBox="0 0 70 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M33.0603 31.5161V25.4742H36.1786C37.4564 25.4742 38.535 25.046 39.4142 24.2016L39.6252 23.9875C41.2313 22.2392 41.1258 19.5156 39.4142 17.898C38.5584 17.0417 37.3861 16.5779 36.1786 16.6016H31.1729V31.5161H33.0603ZM33.0605 23.6426V18.4332H36.2262C36.9063 18.4332 37.5512 18.6949 38.0319 19.1706C39.052 20.1697 39.0754 21.8348 38.0905 22.8695C37.6098 23.3809 36.9297 23.6664 36.2262 23.6426H33.0605ZM48.4293 22.1084C47.6204 21.3591 46.5185 20.9785 45.1234 20.9785C43.3298 20.9785 41.9816 21.6445 41.0906 22.9647L42.7553 24.0232C43.3649 23.1193 44.1973 22.6673 45.2524 22.6673C45.9206 22.6673 46.5653 22.9171 47.0694 23.3691C47.5618 23.7972 47.8432 24.4157 47.8432 25.0698V25.5099C47.1163 25.1055 46.2019 24.8914 45.0765 24.8914C43.7635 24.8914 42.7084 25.2007 41.923 25.831C41.1375 26.4614 40.739 27.2939 40.739 28.3525C40.7155 29.3158 41.1258 30.2316 41.8527 30.8501C42.5912 31.5161 43.5291 31.8491 44.631 31.8491C45.9323 31.8491 46.9639 31.2664 47.7494 30.1008H47.8314V31.5161H49.6368V25.2245C49.6368 23.9043 49.2382 22.8576 48.4293 22.1084ZM43.3066 29.6369C42.9197 29.3515 42.6852 28.8877 42.6852 28.3881C42.6852 27.8291 42.9432 27.3653 43.4473 26.9966C43.9632 26.6279 44.6081 26.4376 45.3702 26.4376C46.4255 26.4257 47.2462 26.6636 47.8325 27.1393C47.8325 27.9481 47.5159 28.6498 46.8945 29.2445C46.3317 29.8153 45.5696 30.1365 44.7723 30.1365C44.2446 30.1484 43.7287 29.97 43.3066 29.6369ZM53.693 36L60.0001 21.3115H57.9485L55.0295 28.6379H54.9943L52.0049 21.3115H49.9534L54.0916 30.862L51.747 36H53.693Z" fill="#3C4043" />
                                                        <path d="M26.5442 24.1659C26.5442 23.5831 26.4973 23.0003 26.4035 22.4295H18.4435V25.724H23.0038C22.8163 26.7825 22.2067 27.734 21.3157 28.3286V30.4695H24.0355C25.6298 28.9828 26.5442 26.7825 26.5442 24.1659Z" fill="#4285F4" />
                                                        <path d="M18.4439 32.539C20.7182 32.539 22.6408 31.7778 24.0358 30.4695L21.3161 28.3287C20.5541 28.852 19.581 29.1493 18.4439 29.1493C16.24 29.1493 14.376 27.6388 13.7078 25.6169H10.9059V27.8291C12.3362 30.7192 15.2552 32.539 18.4439 32.539Z" fill="#34A853" />
                                                        <path d="M13.708 25.617C13.3563 24.5584 13.3563 23.4048 13.708 22.3344V20.134H10.9058C9.69808 22.5484 9.69808 25.4029 10.9058 27.8173L13.708 25.617Z" fill="#FBBC04" />
                                                        <path d="M18.4439 18.8019C19.6514 18.7782 20.812 19.242 21.6795 20.0864L24.0944 17.6364C22.5587 16.1854 20.5423 15.3885 18.4439 15.4123C15.2552 15.4123 12.3362 17.2439 10.9059 20.134L13.7078 22.3462C14.376 20.3124 16.24 18.8019 18.4439 18.8019Z" fill="#EA4335" />
                                                    </svg>

                                                </div> : ''
                                        }
                                        {
                                            this.state.model.showTrustBadgesApplePay ?
                                                <div className="trustbadgeicons">

                                                    <svg width="50" height="48" viewBox="0 0 70 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6924 17.8659C17.6325 17.9452 18.5726 17.3901 19.1601 16.6863C19.7379 15.9627 20.1198 14.9913 20.0219 14C19.1895 14.0397 18.1613 14.5551 17.5737 15.2787C17.0352 15.9032 16.5749 16.9143 16.6924 17.8659ZM27.8755 30.6333V15.1796H33.6041C36.5615 15.1796 38.6277 17.2414 38.6277 20.2548C38.6277 23.2683 36.5223 25.3499 33.5258 25.3499H30.2453V30.6333H27.8755ZM20.012 18.0542C19.1838 18.006 18.4281 18.3064 17.8177 18.549C17.4249 18.7051 17.0923 18.8373 16.8392 18.8373C16.5552 18.8373 16.2089 18.6981 15.82 18.5417L15.82 18.5417L15.82 18.5417L15.82 18.5417C15.3104 18.3368 14.7278 18.1025 14.1169 18.1137C12.7166 18.1335 11.4142 18.9365 10.6993 20.2152C9.23044 22.7726 10.3174 26.5593 11.7373 28.6409C12.4326 29.6718 13.265 30.8018 14.3617 30.7622C14.8442 30.7438 15.1913 30.5947 15.5505 30.4404C15.9641 30.2628 16.3937 30.0782 17.0645 30.0782C17.712 30.0782 18.1228 30.2579 18.5172 30.4305C18.8921 30.5945 19.2522 30.752 19.7868 30.7424C20.9227 30.7225 21.6376 29.7115 22.3328 28.6806C23.0831 27.5741 23.4129 26.4943 23.4629 26.3304L23.4688 26.3114C23.4676 26.3102 23.4583 26.3059 23.4419 26.2984C23.1911 26.1821 21.274 25.2937 21.2557 22.9114C21.2372 20.9118 22.7762 19.8987 23.0185 19.7392C23.0332 19.7295 23.0432 19.723 23.0477 19.7196C22.0684 18.2525 20.5408 18.0939 20.012 18.0542ZM42.9561 30.7523C44.4445 30.7523 45.8253 29.989 46.452 28.7797H46.501V30.6333H48.6945V22.9412C48.6945 20.7108 46.9318 19.2735 44.2193 19.2735C41.7026 19.2735 39.842 20.7307 39.7735 22.733H41.9083C42.0845 21.7814 42.9561 21.1569 44.1508 21.1569C45.6 21.1569 46.4128 21.8409 46.4128 23.0998V23.9522L43.4555 24.1307C40.7038 24.2992 39.2153 25.4391 39.2153 27.4217C39.2153 29.424 40.7527 30.7523 42.9561 30.7523ZM43.5924 28.9185C42.3292 28.9185 41.5262 28.3039 41.5262 27.3622C41.5262 26.3908 42.2998 25.8257 43.7785 25.7365L46.4127 25.568V26.4403C46.4127 27.8876 45.1984 28.9185 43.5924 28.9185ZM55.9702 31.238C55.0204 33.9442 53.9334 34.8363 51.6224 34.8363C51.4461 34.8363 50.8585 34.8165 50.7214 34.7768V32.9232C50.8683 32.943 51.2307 32.9628 51.4167 32.9628C52.4645 32.9628 53.0521 32.5167 53.4144 31.357L53.6298 30.673L49.6149 19.4222H52.0924L54.8833 28.5517H54.9322L57.7231 19.4222H60.1321L55.9702 31.238ZM30.2451 17.2018H32.9772C35.0336 17.2018 36.2087 18.312 36.2087 20.2648C36.2087 22.2175 35.0336 23.3377 32.9674 23.3377H30.2451V17.2018Z" fill="black" />
                                                    </svg>

                                                </div> : ''
                                        }
                                    </div> : ''
                            }

                            {
                                this.state.visibleItem ?
                                    <div className={'satcb-cs-footer' + (this.state.model.stickyFooter ? ' satcb-cs-footer-sticky' : '')}>
                                        <div className="satcb-cs-footer-subtotal">
                                            <span>{this.state.model.subtotal_Translation}</span><span>{this.getCurrencySymbol() + this.state.model.demoProduct.defaultVariant.price}</span>
                                        </div>
                                        <div>
                                            <div className="satcb-cs-taxes-shipping-note">{this.state.model.taxesAndShippingNote_Translation}</div>
                                            <a href="/#" onClick={(e) => e.preventDefault()} style={{ backgroundColor: this.state.model.checkoutButtonBackgroundColor, color: this.state.model.checkoutButtonColor }} className="satcb-cs-checkout-btn">{this.state.model.checkoutButtonText_Translation}</a>
                                            {
                                                this.state.model.showViewCart ?
                                                    <a href="/#" className="satcb-cs-view-cart" onClick={(e) => e.preventDefault()}>{this.state.model.viewCartText_Translation}</a> : ''
                                            }
                                            {
                                                this.state.model.showContinueShopping ?
                                                    <a href="/#" className="satcb-cs-continue-shopping" onClick={(e) => e.preventDefault()}>{this.state.model.continueShoppingText_Translation}</a> : ''
                                            }
                                        </div>
                                    </div> : ''
                            }
                        </div>
                    </div>
                    <Layout>
                        <Layout.Section>
                            <Banner
                                title="What is Cart Slider?"
                                status="info"
                            >
                                <p>Cart Slider is interactive cart drawer that improves UX and will show on add to cart instead of redirecting to Cart page. Enable Cart Reserved, Shipping Bar, and In Cart Upsell to reduce cart abandonment and increase AOV.</p>
                            </Banner>
                        </Layout.Section>
                        <Layout.Section>
                            <div id="preview" className="preview-hidden">
                                <Card title="Preview" sectioned actions={[{ content: this.state.previewActive ? 'Hide' : 'Show', onAction: this.togglePreviewActive }]}>
                                </Card>
                            </div>
                        </Layout.Section>
                        <Layout.AnnotatedSection
                            title="Cart Slider State"
                        >
                            <div className="setting-toggle-card">
                                <Card>
                                    <SettingToggle action={{
                                        content: this.state.model.enabled ? 'Disable' : 'Enable',
                                        onAction: () => { this.handleChange('enabled', !this.state.model.enabled) }
                                    }}
                                        enabled={this.state.model.enabled}
                                    >
                                        Cart Slider is currently <Text as="span" fontWeight="semibold">{this.state.model.enabled ? 'enabled' : 'disabled'}</Text>.
                                    </SettingToggle>
                                    <Card.Section>
                                        <TextContainer>
                                            <Banner>
                                                <p>
                                                    Please note, if your theme has a popup/drawer cart you should disable it in the theme settings.
                                                </p>
                                            </Banner>
                                        </TextContainer>
                                    </Card.Section>
                                </Card>
                            </div>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection title="Settings">
                            <Card>
                                <Card.Section>
                                    <FormLayout>
                                        <Checkbox
                                            label="Open on Add to Cart"
                                            checked={this.state.model.openOnAddToCart}
                                            onChange={(newValue) => this.handleChange('openOnAddToCart', newValue)}
                                        />
                                        {
                                            this.state.model.openOnAddToCart ?
                                                <FormLayout.Group>
                                                    <Checkbox
                                                        label="Close after"
                                                        checked={this.state.model.closeAfter}
                                                        onChange={(newValue) => this.handleChange('closeAfter', newValue)}
                                                    />
                                                    <TextField
                                                        id="cartSlider_closeAfterSeconds"
                                                        suffix="seconds"
                                                        type="number"
                                                        min="2"
                                                        disabled={!this.state.model.closeAfter}
                                                        value={this.state.model.closeAfterSeconds}
                                                        onChange={(newValue) => this.handleChange('closeAfterSeconds', newValue)}
                                                        error={this.state.error.closeAfterSeconds ? 'Value must be greater than or equal to 2' : ''}
                                                        onBlur={() => this.handleBlur('closeAfterSeconds', 2)}
                                                    />
                                                </FormLayout.Group> : ''
                                        }
                                        <Checkbox
                                            label="Show View Cart link"
                                            checked={this.state.model.showViewCart}
                                            onChange={(newValue) => this.handleChange('showViewCart', newValue)}
                                        />
                                        <Checkbox
                                            label="Show Continue shopping link"
                                            checked={this.state.model.showContinueShopping}
                                            onChange={(newValue) => this.handleChange('showContinueShopping', newValue)}
                                        />
                                        <Checkbox
                                            label="Fixed Footer"
                                            checked={this.state.model.stickyFooter}
                                            onChange={(newValue) => this.handleChange('stickyFooter', newValue)}
                                        />
                                        <Checkbox
                                            label="Show Trust Badges"
                                            checked={this.state.model.showTrustBadges}
                                            onChange={(newValue) => this.handleChange('showTrustBadges', newValue)}
                                        />
                                        {
                                            this.state.model.showTrustBadges ?
                                                <FormLayout.Group>
                                                    <Checkbox
                                                        label="Visa"
                                                        checked={this.state.model.showTrustBadgesVisa}
                                                        onChange={(newValue) => this.handleChange('showTrustBadgesVisa', newValue)}
                                                    />
                                                    <Checkbox
                                                        label="Mastercard"
                                                        checked={this.state.model.showTrustBadgesMastercard}
                                                        onChange={(newValue) => this.handleChange('showTrustBadgesMastercard', newValue)}
                                                    />
                                                    <Checkbox
                                                        label="American Express"
                                                        checked={this.state.model.showTrustBadgesAmericanExpress}
                                                        onChange={(newValue) => this.handleChange('showTrustBadgesAmericanExpress', newValue)}
                                                    />
                                                    <Checkbox
                                                        label="Paypal"
                                                        checked={this.state.model.showTrustBadgesPaypal}
                                                        onChange={(newValue) => this.handleChange('showTrustBadgesPaypal', newValue)}
                                                    />
                                                    <Checkbox
                                                        label="G Pay"
                                                        checked={this.state.model.showTrustBadgesGPay}
                                                        onChange={(newValue) => this.handleChange('showTrustBadgesGPay', newValue)}
                                                    />
                                                    <Checkbox
                                                        label="Apple Pay"
                                                        checked={this.state.model.showTrustBadgesApplePay}
                                                        onChange={(newValue) => this.handleChange('showTrustBadgesApplePay', newValue)}
                                                    />
                                                </FormLayout.Group> : ''
                                        }
                                        <TextField
                                            value={this.state.model.cartButtonCSSSelector}
                                            onChange={(newValue) => this.handleChange('cartButtonCSSSelector', newValue)}
                                            label="Cart button CSS selector"
                                        />
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="Translations">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <TextField
                                                value={this.state.model.cartTitle_Translation}
                                                onChange={(newValue) => this.handleChange('cartTitle_Translation', newValue)}
                                                label="Cart title"
                                            />
                                            <TextField
                                                value={this.state.model.cartEmptyText_Translation}
                                                onChange={(newValue) => this.handleChange('cartEmptyText_Translation', newValue)}
                                                label="Cart empty text"
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <TextField
                                                value={this.state.model.checkoutButtonText_Translation}
                                                onChange={(newValue) => this.handleChange('checkoutButtonText_Translation', newValue)}
                                                label="Checkout button text"
                                            />
                                            <TextField
                                                value={this.state.model.continueShoppingText_Translation}
                                                onChange={(newValue) => this.handleChange('continueShoppingText_Translation', newValue)}
                                                label="Continue shopping text"
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <TextField
                                                value={this.state.model.subtotal_Translation}
                                                onChange={(newValue) => this.handleChange('subtotal_Translation', newValue)}
                                                label="Subtotal label"
                                            />
                                            <TextField
                                                value={this.state.model.viewCartText_Translation}
                                                onChange={(newValue) => this.handleChange('viewCartText_Translation', newValue)}
                                                label="View Cart Text"
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <TextField
                                                value={this.state.model.taxesAndShippingNote_Translation}
                                                onChange={(newValue) => this.handleChange('taxesAndShippingNote_Translation', newValue)}
                                                label="Taxes And Shipping Note"
                                            />
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="Look and Feel">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Checkout Button Background Color"
                                                fieldName="checkoutButtonBackgroundColor"
                                                value={this.state.model.checkoutButtonBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Checkout Button Color"
                                                fieldName="checkoutButtonColor"
                                                value={this.state.model.checkoutButtonColor}
                                                handleChange={this.handleChange}
                                            />
                                            <Select
                                                label="Section Font Size"
                                                options={[{ label: "Small", value: JSON.stringify(fontStepValSmall) }, { label: "Medium", value: "" }, { label: "Large", value: JSON.stringify(fontStepValIncrease) }, { label: "Extra Large", value: JSON.stringify(fontStepValIncrease + 2) }]}
                                                onChange={this.handleSectionSettings}
                                                value={this.state.model.titleFontSize}
                                            />

                                            <Select
                                                label="Override Font Face"
                                                options={[{ label: 'Default', value: "" }, { label: 'Roboto', value: 'Roboto' }, { label: 'Playfair Display', value: 'Playfair Display' }, { label: 'Open Sans', value: 'Open Sans' }, { label: 'Oswald', value: 'Oswald' }, { label: 'Cabin', value: 'Cabin' }, { label: 'Montserrat', value: 'Montserrat' }, { label: 'Merriweather', value: 'Merriweather' }, { label: 'Cormorant', value: 'Cormorant' }, { label: 'Poppins', value: 'Poppins' }, { label: 'Nunito', value: 'Nunito' }, { label: 'Lato', value: 'Lato' }]}
                                                onChange={(newValue) => this.handleChange('fontFace', newValue)}
                                                value={this.state.model.fontFace}
                                            />

                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection title="Cart Reserved">
                            <Card sectioned>
                                <FormLayout>
                                    <Checkbox
                                        label="Enabled"
                                        checked={this.state.model.enabled_CartReserved}
                                        onChange={(newValue) => this.handleChange('enabled_CartReserved', newValue)}
                                    />
                                    {this.state.model.enabled_CartReserved && <span>
                                        <FormLayout.Group>
                                            <TextField
                                                id="cartSlider_countdownMinutes_CartReserved"
                                                label="Timer Duration"
                                                suffix="Minute(s)"
                                                type="number"
                                                min="1"
                                                value={this.state.model.countdownMinutes_CartReserved}
                                                onChange={(newValue) => this.handleChange('countdownMinutes_CartReserved', newValue)}
                                                error={this.state.error.countdownMinutes_CartReserved ? 'Value must be greater than or equal to 1' : ''}
                                                onBlur={() => this.handleBlur('countdownMinutes_CartReserved', 1)}
                                            />
                                            <ColorPickerCustom
                                                label="Color of Timer"
                                                fieldName="colorOfTimer_CartReserved"
                                                value={this.state.model.colorOfTimer_CartReserved}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Background Color"
                                                fieldName="backgroundColor_CartReserved"
                                                value={this.state.model.backgroundColor_CartReserved}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Text Color"
                                                fieldName="textColor_CartReserved"
                                                value={this.state.model.textColor_CartReserved}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Border Color"
                                                fieldName="borderColor_CartReserved"
                                                value={this.state.model.borderColor_CartReserved}
                                                handleChange={this.handleChange}
                                            />
                                            <TextField
                                                label="Border Radius"
                                                suffix="px"
                                                type="number"
                                                value={this.state.model.borderRadius_CartReserved}
                                                onChange={(newValue) => this.handleChange('borderRadius_CartReserved', newValue)}
                                                clearButton
                                                onClearButtonClick={() => this.handleChange('borderRadius_CartReserved', null)}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <Select
                                                label="Remove items from cart after timer expires"
                                                options={[{ label: "Don't remove items", value: '0' }, { label: 'Only remove low inventory items', value: '1' }, { label: 'Remove all items', value: '2' },]}
                                                onChange={(newValue) => this.handleChangeOptions(newValue)}
                                                value={this.state.model.selectedRemoveProductOption_CartReserved}
                                            />

                                            <TextField
                                                label="Thresold inventory level"
                                                suffix="items"
                                                type="number"
                                                min="1"
                                                disabled={!this.state.model.clearLowQuantityItemsFromCartOnTimerEnd_CartReserved}
                                                value={this.state.model.lowQuantityThreshold_CartReserved}
                                                onChange={(newValue) => this.handleChange('lowQuantityThreshold_CartReserved', newValue)}
                                            />
                                        </FormLayout.Group>
                                        <TextField
                                            id="cartSlider_notShowHours_CartReserved"
                                            label="Do not show expired Timer to the same visitor again for a number of hours"
                                            suffix="Hour(s)"
                                            type="number"
                                            min="0"
                                            value={this.state.model.notShowHours_CartReserved}
                                            onChange={(newValue) => this.handleChange('notShowHours_CartReserved', newValue)}
                                            error={this.state.error.notShowHours_CartReserved ? 'Value must be greater than or equal to 0' : ''}
                                            onBlur={() => this.handleBlur('notShowHours_CartReserved', 0)}
                                        />
                                        <TextField
                                            value={this.state.model.message_CartReserved}
                                            onChange={(newValue) => this.handleChange('message_CartReserved', newValue)}
                                            label="Message"
                                        />
                                        <FormLayout.Group>
                                            <TextField
                                                value={this.state.model.messageBeforeTimer_CartReserved}
                                                onChange={(newValue) => this.handleChange('messageBeforeTimer_CartReserved', newValue)}
                                                label="Message before timer"
                                            />
                                            <TextField
                                                value={this.state.model.messageAfterTimer_CartReserved}
                                                onChange={(newValue) => this.handleChange('messageAfterTimer_CartReserved', newValue)}
                                                label="Message after timer"
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <EmojiPickerCustom
                                                label="Emoji in front of the message"
                                                fieldName="emoji_CartReserved"
                                                value={this.state.model.emoji_CartReserved}
                                                handleChange={this.handleChange}
                                            />
                                            <TextField
                                                id="cartSlider_countdownMinutes_CartReserved"
                                                label="Message font size"
                                                suffix="px"
                                                type="number"
                                                min="1"
                                                value={this.state.model.messageFontSize_CartReserved}
                                                onChange={(newValue) => this.handleChange('messageFontSize_CartReserved', newValue)}
                                                error={this.state.error.messageFontSize_CartReserved ? 'Value must be greater than or equal to 1' : ''}
                                                onBlur={() => this.handleBlur('messageFontSize_CartReserved', 1)}
                                            />
                                        </FormLayout.Group>
                                        <Select
                                            label="Position"
                                            options={[{ label: 'Top', value: 'top' }, { label: 'Bottom', value: 'bottom' }]}
                                            onChange={(newValue) => this.handleChange('position_CartReserved', newValue)}
                                            value={this.state.model.position_CartReserved}
                                        />

                                        <Select
                                            label="Cart message Font Size"
                                            options={[{ label: "Small", value: JSON.stringify(fontStepValSmall) }, { label: "Medium", value: "" }, { label: "Large", value: JSON.stringify(fontStepValIncrease) }, { label: "Extra Large", value: JSON.stringify(fontStepValIncrease + 2) }]}
                                            onChange={this.handleCartReserve}
                                            value={this.state.model.cartInfoFontSize_CartReserved}

                                        />

                                    </span>}




                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection title="Shipping Bar">
                            <Card sectioned>
                                <FormLayout>
                                    <Checkbox
                                        label="Enabled"
                                        checked={this.state.model.enabled_ShippingBar}
                                        onChange={(newValue) => this.handleChange('enabled_ShippingBar', newValue)}
                                    />
                                    {this.state.model.enabled_ShippingBar && <span>

                                        <CountryPickerCustom
                                            options={this.state.common.countries}
                                            label="Countries eligible for free shipping (leave empty for all)"
                                            fieldName="eligibleCountries_ShippingBar"
                                            value={this.state.model.eligibleCountries_ShippingBar}
                                            handleChange={this.handleChange}
                                        />
                                        <FormLayout.Group>
                                            <TextField
                                                id="cartSlider_minAmount_ShippingBar"
                                                label="Min Amount to Spend"
                                                suffix={this.state.common.currency}
                                                type="number"
                                                min="0"
                                                value={this.state.model.minAmount_ShippingBar}
                                                onChange={(newValue) => this.handleChange('minAmount_ShippingBar', newValue)}
                                                error={this.state.error.minAmount_ShippingBar ? 'Value must be greater than or equal to 0' : ''}
                                                onBlur={() => this.handleBlur('minAmount_ShippingBar', 0)}
                                            />
                                            <ColorPickerCustom
                                                label="Amount Color"
                                                fieldName="amountColor_ShippingBar"
                                                value={this.state.model.amountColor_ShippingBar}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Background Color"
                                                fieldName="backgroundColor_ShippingBar"
                                                value={this.state.model.backgroundColor_ShippingBar}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Text Color"
                                                fieldName="textColor_ShippingBar"
                                                value={this.state.model.textColor_ShippingBar}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <TextField
                                                value={this.state.model.initialMessageBeforeAmount_ShippingBar}
                                                onChange={(newValue) => this.handleChange('initialMessageBeforeAmount_ShippingBar', newValue)}
                                                label="Initial message before amount"
                                            />
                                            <TextField
                                                value={this.state.model.initialMessageAfterAmount_ShippingBar}
                                                onChange={(newValue) => this.handleChange('initialMessageAfterAmount_ShippingBar', newValue)}
                                                label="Initial message after amount"
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <TextField
                                                value={this.state.model.progressMessageBeforeAmount_ShippingBar}
                                                onChange={(newValue) => this.handleChange('progressMessageBeforeAmount_ShippingBar', newValue)}
                                                label="Progress message before amount"
                                            />
                                            <TextField
                                                value={this.state.model.progressMessageAfterAmount_ShippingBar}
                                                onChange={(newValue) => this.handleChange('progressMessageAfterAmount_ShippingBar', newValue)}
                                                label="Progress message after amount"
                                            />
                                        </FormLayout.Group>
                                        <TextField
                                            value={this.state.model.goalAchievedMessage_ShippingBar}
                                            onChange={(newValue) => this.handleChange('goalAchievedMessage_ShippingBar', newValue)}
                                            label="Goal achieved message"
                                            helpText={<div>You can use emojis as well, copy them from <a href="https://getemoji.com/" rel="nofollow noopener noreferrer" target="_blank">this page</a>.</div>}
                                        />
                                        <Checkbox
                                            label="Show customer's country"
                                            checked={this.state.model.showShopperCountry_ShippingBar}
                                            onChange={(newValue) => this.handleChange('showShopperCountry_ShippingBar', newValue)}
                                        />
                                        <FormLayout.Group>
                                            <TextField
                                                value={this.state.model.messageBeforeCountry_ShippingBar}
                                                onChange={(newValue) => this.handleChange('messageBeforeCountry_ShippingBar', newValue)}
                                                label="Message before country"
                                            />
                                            <TextField
                                                value={this.state.model.messageAfterCountry_ShippingBar}
                                                onChange={(newValue) => this.handleChange('messageAfterCountry_ShippingBar', newValue)}
                                                label="Message after country"
                                            />
                                        </FormLayout.Group>
                                        <Checkbox
                                            label="Show Progress Bar"
                                            checked={this.state.model.showProgressBar_ShippingBar}
                                            onChange={(newValue) => this.handleChange('showProgressBar_ShippingBar', newValue)}
                                        />
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Progress Background Color"
                                                fieldName="progressBackgroundColor_ShippingBar"
                                                value={this.state.model.progressBackgroundColor_ShippingBar}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Progress Bar Color"
                                                fieldName="progressBarColor_ShippingBar"
                                                value={this.state.model.progressBarColor_ShippingBar}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <Checkbox
                                            label="Show Close Button"
                                            checked={this.state.model.showCloseButton_ShippingBar}
                                            onChange={(newValue) => this.handleChange('showCloseButton_ShippingBar', newValue)}
                                        />
                                        <Select
                                            label="Position"
                                            options={[{ label: 'Top', value: 'top' }, { label: 'Bottom', value: 'bottom' }]}
                                            onChange={(newValue) => this.handleChange('position_ShippingBar', newValue)}
                                            value={this.state.model.position_ShippingBar}
                                        />
                                        <Select
                                            label="Shipping Cart Font Size"
                                            options={[{ label: "Small", value: JSON.stringify(fontStepValSmall) }, { label: "Medium", value: "" }, { label: "Large", value: JSON.stringify(fontStepValIncrease) }, { label: "Extra Large", value: JSON.stringify(fontStepValIncrease + 2) }]}
                                            onChange={this.handleShippingCart}
                                            value={this.state.model.shippingFontSize_ShippingBar}
                                        />
                                    </span>}
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection title="In Cart Upsell">
                            <Card>
                                <Card.Section>
                                    <FormLayout>
                                        <Checkbox
                                            label="Enabled"
                                            checked={this.state.model.enabled_InCartUpsell}
                                            onChange={(newValue) => this.handleChange('enabled_InCartUpsell', newValue)}
                                        />
                                        {this.state.model.enabled_InCartUpsell && <span>

                                            <Checkbox
                                                label="Show Price"
                                                checked={this.state.model.showPrice_InCartUpsell}
                                                onChange={(newValue) => this.handleChange('showPrice_InCartUpsell', newValue)}
                                            />
                                            <br />
                                            <Checkbox
                                                label="Show Compare Price"
                                                checked={this.state.model.showComparePrice_InCartUpsell}
                                                onChange={(newValue) => this.handleChange('showComparePrice_InCartUpsell', newValue)}
                                            />
                                            <br />

                                            <Checkbox
                                                label="Show Variants Dropdown"
                                                checked={this.state.model.showVariantsDropdown_InCartUpsell}
                                                onChange={(newValue) => this.handleChange('showVariantsDropdown_InCartUpsell', newValue)}
                                            />
                                            <br />

                                            <Checkbox
                                                label="Show Quantity Box"
                                                checked={this.state.model.showQuantityBox_InCartUpsell}
                                                onChange={(newValue) => this.handleChange('showQuantityBox_InCartUpsell', newValue)}
                                            />
                                            <br />
                                            <br />

                                            <LegacyStack vertical spacing="tight">
                                                <LegacyStack wrap={false} alignment="center" spacing="tight">
                                                    <Checkbox
                                                        label="Enable Tracking"
                                                        checked={this.state.model.trackingEnabled_InCartUpsell}
                                                        onChange={(newValue) => this.handleChange('trackingEnabled_InCartUpsell', newValue)}

                                                    />
                                                    <Tooltip content="This attribute can be used for app auditing and will appear in your Shopify order details page. The attribute name is _Added from Sticky Add To Cart BOOSTER PRO's Cart Slider. This is not visible to your customers.">
                                                        <div style={{ lineHeight: 'normal', marginLeft: '4px' }}>
                                                            <Icon source={InfoMinor} color="inkLightest" />
                                                        </div>
                                                    </Tooltip>
                                                </LegacyStack>
                                            </LegacyStack>
                                            <br />

                                            <TextField
                                                value={this.state.model.overwriteProductName_Translation_InCartUpsell}
                                                onChange={(newValue) => this.handleChange('overwriteProductName_Translation_InCartUpsell', newValue)}
                                                label="Overwrite Product Name"
                                            />
                                            <br />
                                            <Select
                                                label="Position"
                                                options={[{ label: 'Top', value: 'top' }, { label: 'Bottom', value: 'bottom' }]}
                                                onChange={(newValue) => this.handleChange('position_InCartUpsell', newValue)}
                                                value={this.state.model.position_InCartUpsell}
                                            />
                                            <br />
                                            <TextContainer>
                                                <Banner title="Product exclusion">
                                                    <p>
                                                        Sometimes you don't want to show some particular product as an upsell.
                                                        Products can be excluded from the upsell by tagging them with the exact text <b>Hidden upsell recommendation</b>
                                                    </p>
                                                </Banner>
                                            </TextContainer>
                                            <br />
                                            <TextContainer>
                                                <Banner title="Disabling recommendations">
                                                    <p>
                                                        If you want some product to not show any recommendations you can tag it with the exact text <b>Upsell recommendations disabled</b>
                                                    </p>
                                                </Banner>
                                            </TextContainer>
                                        </span>}

                                    </FormLayout>
                                </Card.Section>
                            </Card>
                        </Layout.AnnotatedSection>

                        {this.state.model.enabled_InCartUpsell && <>

                            <Layout.AnnotatedSection>
                                <Card>
                                    <Card.Section title="Translations">
                                        <FormLayout>
                                            <FormLayout.Group>
                                                <TextField
                                                    value={this.state.model.addToCart_Translation_InCartUpsell}
                                                    onChange={(newValue) => this.handleChange('addToCart_Translation_InCartUpsell', newValue)}
                                                    label="Add to cart"
                                                />
                                                <TextField
                                                    value={this.state.model.buyNow_Translation_InCartUpsell}
                                                    onChange={(newValue) => this.handleChange('buyNow_Translation_InCartUpsell', newValue)}
                                                    label="Buy now"
                                                />
                                            </FormLayout.Group>
                                            <FormLayout.Group>
                                                <TextField
                                                    value={this.state.model.titleBeforeText_Translation_InCartUpsell}
                                                    onChange={(newValue) => this.handleChange('titleBeforeText_Translation_InCartUpsell', newValue)}
                                                    label="Text Before Product Name"
                                                />
                                                <TextField
                                                    value={this.state.model.titleAfterText_Translation_InCartUpsell}
                                                    onChange={(newValue) => this.handleChange('titleAfterText_Translation_InCartUpsell', newValue)}
                                                    label="Text After Product Name"
                                                />
                                            </FormLayout.Group>
                                            <FormLayout.Group>
                                                <TextField
                                                    value={this.state.model.soldOut_Translation_InCartUpsell}
                                                    onChange={(newValue) => this.handleChange('soldOut_Translation_InCartUpsell', newValue)}
                                                    label="Sold out"
                                                />
                                                <TextField
                                                    value={this.state.model.addedToCartMessage_Translation_InCartUpsell}
                                                    onChange={(newValue) => this.handleChange('addedToCartMessage_Translation_InCartUpsell', newValue)}
                                                    label="Added to Cart Message"
                                                />
                                            </FormLayout.Group>
                                        </FormLayout>
                                    </Card.Section>
                                </Card>
                            </Layout.AnnotatedSection>
                            <Layout.AnnotatedSection>
                                <Card>
                                    <Card.Section title="Look and Feel">
                                        <FormLayout>
                                            <FormLayout.Group>
                                                <ColorPickerCustom
                                                    label="Background Color"
                                                    fieldName="backgroundColor_InCartUpsell"
                                                    value={this.state.model.backgroundColor_InCartUpsell}
                                                    handleChange={this.handleChange}
                                                />
                                                <ColorPickerCustom
                                                    label="Title Color"
                                                    fieldName="titleColor_InCartUpsell"
                                                    value={this.state.model.titleColor_InCartUpsell}
                                                    handleChange={this.handleChange}
                                                />
                                            </FormLayout.Group>
                                            <FormLayout.Group>
                                                <ColorPickerCustom
                                                    label="Product Link Color"
                                                    fieldName="productLinkColor_InCartUpsell"
                                                    value={this.state.model.productLinkColor_InCartUpsell}
                                                    handleChange={this.handleChange}
                                                />
                                                <div></div>
                                            </FormLayout.Group>
                                            <FormLayout.Group>
                                                <ColorPickerCustom
                                                    label="Product Price Color"
                                                    fieldName="productPriceColor_InCartUpsell"
                                                    value={this.state.model.productPriceColor_InCartUpsell}
                                                    handleChange={this.handleChange}
                                                />
                                                <ColorPickerCustom
                                                    label="Product Compare Price Color"
                                                    fieldName="productComparePriceColor_InCartUpsell"
                                                    value={this.state.model.productComparePriceColor_InCartUpsell}
                                                    handleChange={this.handleChange}
                                                />
                                            </FormLayout.Group>
                                            <FormLayout.Group>
                                                <ColorPickerCustom
                                                    label="Button Background Color"
                                                    fieldName="buttonBackgroundColor_InCartUpsell"
                                                    value={this.state.model.buttonBackgroundColor_InCartUpsell}
                                                    handleChange={this.handleChange}
                                                />
                                                <ColorPickerCustom
                                                    label="Button Background Color on Hover"
                                                    fieldName="buttonBackgroundColorOnHover_InCartUpsell"
                                                    value={this.state.model.buttonBackgroundColorOnHover_InCartUpsell}
                                                    handleChange={this.handleChange}
                                                />
                                            </FormLayout.Group>
                                            <FormLayout.Group>
                                                <ColorPickerCustom
                                                    label="Button Text Color"
                                                    fieldName="buttonTextColor_InCartUpsell"
                                                    value={this.state.model.buttonTextColor_InCartUpsell}
                                                    handleChange={this.handleChange}
                                                />
                                                <ColorPickerCustom
                                                    label="Button Text Color on Hover"
                                                    fieldName="buttonTextColorOnHover_InCartUpsell"
                                                    value={this.state.model.buttonTextColorOnHover_InCartUpsell}
                                                    handleChange={this.handleChange}
                                                />

                                                <Select
                                                    label="Cart Upsell Font Size"
                                                    options={[{ label: "Small", value: JSON.stringify(fontStepValSmall) }, { label: "Medium", value: "" }, { label: "Large", value: JSON.stringify(fontStepValIncrease) }, { label: "Extra Large", value: JSON.stringify(fontStepValIncrease + 2) }]}
                                                    onChange={this.handleInCartUpsell}
                                                    value={this.state.model.cartFontSize_InCartUpsell}
                                                />
                                            </FormLayout.Group>
                                        </FormLayout>
                                    </Card.Section>
                                </Card>
                            </Layout.AnnotatedSection>
                            <Layout.AnnotatedSection>
                                <Card>
                                    <Card.Section title={<h3 id="custom-bundles" aria-label="Custom Bundles" className="Polaris-Subheading">Custom Bundles</h3>} actions={[{ content: 'Add bundle', url: '/upsell-bundle' + this.state.common.shopQueryString + token }]}>
                                        <FormLayout>
                                            <ResourceList
                                                resourceName={{ singular: 'bundle', plural: 'bundles' }}
                                                items={this.state.model.bundles_InCartUpsell ? this.state.model.bundles_InCartUpsell : []}

                                                renderItem={(item) => {
                                                    const { id, name } = item;


                                                    return (
                                                        <ResourceItem
                                                            id={id}
                                                            url={'/upsell-bundle/' + this.state.common.shopQueryString + token}
                                                            accessibilityLabel={`View details for ${name}`}
                                                            name={name}
                                                            onClick={() => { this.props.setBundleID(id) }}
                                                        >
                                                            <h3>
                                                                <Text as="span" fontWeight="semibold">{name}</Text>
                                                            </h3>
                                                        </ResourceItem>
                                                    );
                                                }}
                                                selectedItems={this.state.selectedBundles}
                                                onSelectionChange={(newValue) => this.selectBundles(newValue)}
                                                bulkActions={[{
                                                    content: 'Delete bundles',
                                                    onAction: () => { this.deleteBundles() },
                                                }]}
                                            />
                                        </FormLayout>
                                    </Card.Section>
                                    <Card.Section title="Global Bundles">
                                        <FormLayout>
                                            <Checkbox
                                                label="Global Bundles Enabled"
                                                checked={this.state.model.globalBundlesEnabled_InCartUpsell}
                                                onChange={(newValue) => this.handleChange('globalBundlesEnabled_InCartUpsell', newValue)}
                                            />
                                            <OptionList
                                                title={<span className='custom-help-text-margin'><b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">Recommendation Methods</b><div className="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--regular"> Each bundle displays differently based on the algorithm or the structure. When multiple bundles are enabled, it follows top to bottom order of priority.
                                                </div></span>}
                                                onChange={(newValue) => this.handleChange('recommendationMethods_InCartUpsell', newValue.sort())}
                                                options={[
                                                    { value: '0', label: lblCustomBundles, disabled: true },
                                                    { value: '1', label: lblSmartRecommendation },
                                                    { value: '3', label: lblSameCollection },
                                                    { value: '4', label: lblSameProductType },
                                                    { value: '5', label: lblSameVendor },
                                                    { value: '6', label: lblRandomProduct },
                                                    { value: '2', label: lblGlobalRecommendation },
                                                ]}
                                                selected={this.state.model.recommendationMethods_InCartUpsell}
                                                allowMultiple
                                            />
                                            {/* <TextContainer>
                                            <Banner>
                                                <p>
                                                    To add products as global recommendations tag them with the exact text  <b>Global upsell recommendations</b>
                                                </p>
                                            </Banner>
                                        </TextContainer> */}
                                            <Checkbox
                                                label="Random Order"
                                                checked={this.state.model.randomOrder_InCartUpsell}
                                                onChange={(newValue) => this.handleChange('randomOrder_InCartUpsell', newValue)}
                                            />
                                            <TextField
                                                id="cartSlider_bundledProductsCount_InCartUpsell"
                                                label="Bundled Products Count"
                                                type="number"
                                                min="1"
                                                value={this.state.model.bundledProductsCount_InCartUpsell}
                                                onChange={(newValue) => this.handleChange('bundledProductsCount_InCartUpsell', newValue)}
                                                error={this.state.error.bundledProductsCount_InCartUpsell ? 'Value must be greater than or equal to 1' : ''}
                                                onBlur={() => this.handleBlur('bundledProductsCount_InCartUpsell', 1)}
                                            />

                                        </FormLayout>
                                    </Card.Section>
                                </Card>
                            </Layout.AnnotatedSection> </>}
                        {/*<Layout.AnnotatedSection title="Coupon Form">*/}
                        {/*    <Card>*/}
                        {/*        <Card.Section>*/}
                        {/*            <FormLayout>*/}
                        {/*                <Checkbox*/}
                        {/*                    label="Enabled"*/}
                        {/*                    checked={this.state.model.showCouponForm}*/}
                        {/*                    onChange={(newValue) => this.handleChange('showCouponForm', newValue)}*/}
                        {/*                />*/}
                        {/*            </FormLayout>*/}
                        {/*        </Card.Section>*/}

                        {/*        {this.state.model.showCouponForm && <span>*/}

                        {/*            <Card.Section title="Translations">*/}
                        {/*                <FormLayout>*/}
                        {/*                    <FormLayout.Group>*/}
                        {/*                        <TextField*/}
                        {/*                            value={this.state.model.textBoxPlaceholder_Translation}*/}
                        {/*                            onChange={(newValue) => this.handleChange('textBoxPlaceholder_Translation', newValue)}*/}
                        {/*                            label="Textbox placeholder"*/}
                        {/*                        />*/}
                        {/*                    </FormLayout.Group>*/}
                        {/*                    <FormLayout.Group>*/}
                        {/*                        <TextField*/}
                        {/*                            value={this.state.model.applyButtonText_Translation}*/}
                        {/*                            onChange={(newValue) => this.handleChange('applyButtonText_Translation', newValue)}*/}
                        {/*                            label="Apply button text"*/}
                        {/*                        />*/}
                        {/*                    </FormLayout.Group>*/}
                        {/*                    <FormLayout.Group>*/}
                        {/*                        <TextField*/}
                        {/*                            value={this.state.model.validCouponCodeNote_Translation}*/}
                        {/*                            onChange={(newValue) => this.handleChange('validCouponCodeNote_Translation', newValue)}*/}
                        {/*                            label="Valid coupon code note"*/}
                        {/*                        />*/}
                        {/*                    </FormLayout.Group>*/}
                        {/*                    <FormLayout.Group>*/}
                        {/*                        <TextField*/}
                        {/*                            value={this.state.model.invalidCouponCodeNote_Translation}*/}
                        {/*                            onChange={(newValue) => this.handleChange('invalidCouponCodeNote_Translation', newValue)}*/}
                        {/*                            label="Invalid coupon code note"*/}
                        {/*                        />*/}
                        {/*                    </FormLayout.Group>*/}
                        {/*                </FormLayout>*/}
                        {/*            </Card.Section>*/}
                        {/*            <Card.Section title="Look and Feel">*/}
                        {/*                <FormLayout>*/}
                        {/*                    <FormLayout.Group>*/}
                        {/*                        <ColorPickerCustom*/}
                        {/*                            label="Apply Button Background Color"*/}
                        {/*                            fieldName="applyButtonBackgroundColor"*/}
                        {/*                            value={this.state.model.applyButtonBackgroundColor}*/}
                        {/*                            handleChange={this.handleChange}*/}
                        {/*                        />*/}
                        {/*                        <ColorPickerCustom*/}
                        {/*                            label="Apply Button Color"*/}
                        {/*                            fieldName="applyButtonColor"*/}
                        {/*                            value={this.state.model.applyButtonColor}*/}
                        {/*                            handleChange={this.handleChange}*/}
                        {/*                        />*/}
                        {/*                    </FormLayout.Group>*/}
                        {/*                </FormLayout>*/}
                        {/*            </Card.Section>*/}
                        {/*        </span>}*/}

                        {/*    </Card>*/}
                        {/*</Layout.AnnotatedSection>*/}


                        <Layout.Section>
                            {window.innerWidth < 768 ?
                                <LegacyStack alignment="center" distribution="center">
                                    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />
                                </LegacyStack>
                                :
                                <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />
                            }
                        </Layout.Section>
                    </Layout>
                </Page >
        );
    }

    async populateData() {

        const response = await fetchApi('api/home/cartSlider');
        const data = await response.json();

        if (data.redirectUrl) {
            this.props.navigate(data.redirectUrl);
        }
        else {
            if (!this.state.common.userName) {
                const commonResponse = await fetchApi('api/home/common');
                const commonData = await commonResponse.json();

                if (commonData.redirectUrl) {
                    this.navigate(commonData.redirectUrl);
                }
                else {
                    this.props.setIsLoading(false);
                    this.setState({ initState: JSON.parse(JSON.stringify(data)), model: data, loading: false, visibleItem: data.demoProduct !== null, common: commonData });
                }
            }
            else {
                this.props.setIsLoading(false);
                this.setState({ initState: JSON.parse(JSON.stringify(data)), model: data, loading: false, visibleItem: data.demoProduct !== null });
            }

            var tgl = this.togglePreviewActive;
            window.$('.satcb-cs').unbind('click').bind('click', function (e) {
                if (e.target.className && e.target.className.split(' ').indexOf('satcb-cs') > -1) {
                    tgl();
                }
            });
        }

        if (typeof (this.state.model.selectedRemoveProductOption_CartReserved) == undefined ||
            (typeof (this.state.model.selectedRemoveProductOption_CartReserved) != undefined && !this.state.model.selectedRemoveProductOption_CartReserved)) {

            if (this.state.model.clearCartOnTimerEnd_CartReserved) {
                this.setState({ selectedRemoveProductOption_CartReserved: '2' });
            } else {
                this.setState({ selectedRemoveProductOption_CartReserved: '0' });
            }
        }
        setTimeout(() => {
            this.updateSectionSettingsPreview(data.titleFontSize, this.getDefaultFontValuesSectionSettings());
            this.updateCartReservePreview(data.cartInfoFontSize_CartReserved, this.getDefaultFontValuesCartReserve());
            this.updateInCartUpsellPreview(data.cartFontSize_InCartUpsell, this.getDefaultFontValuesInCartUpsell())
            this.updateShippingCartPreview(data.shippingFontSize_ShippingBar, this.getDefaultFontValuesShippingCart())
        }, 1000)

    }

    async saveChanges() {

        var hasError = this.handleBlur('closeAfterSeconds', 2);
        if (hasError) {
            $('#cartSlider_closeAfterSeconds').focus();
            return;
        }

        hasError = this.handleBlur('countdownMinutes_CartReserved', 1);
        if (hasError) {
            $('#cartSlider_countdownMinutes_CartReserved').focus();
            return;
        }

        hasError = this.handleBlur('notShowHours_CartReserved', 0);
        if (hasError) {
            $('#cartSlider_notShowHours_CartReserved').focus();
            return;
        }

        hasError = this.handleBlur('messageFontSize_CartReserved', 1);
        if (hasError) {
            $('#cartSlider_messageFontSize_CartReserved').focus();
            return;
        }

        hasError = this.handleBlur('minAmount_ShippingBar', 0);
        if (hasError) {
            $('#cartSlider_minAmount_ShippingBar').focus();
            return;
        }

        hasError = this.handleBlur('bundledProductsCount_InCartUpsell', 1);
        if (hasError) {
            $('#cartSlider_bundledProductsCount_InCartUpsell').focus();
            return;
        }

        this.props.setIsLoading(true);
        const response = await fetchApi('api/home/saveCartSlider', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.model) });
        const data = await response.json();

        this.props.setIsLoading(false);

        if (response.ok === true) {
            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
            else {
                this.setState({ initState: JSON.parse(JSON.stringify(this.state.model)) });
                this.props.setIsDirty(false);
                this.props.setToastActive(true);
            }
        }
    }

}